/* eslint-disable @typescript-eslint/indent */
import { Container } from '@pwskills/rachnaui';
import React, { useState, useEffect, useContext } from 'react';
import courseDescriptionContext from '@/context/CourseDescriptionContext';
import { ICurriculum } from '@/interfaces/courseDescription';
import ProfessionalThemeHeader from '@/components/common/Header/ProfessionalThemeHeader';
import DownloadCurriculum from './DownloadCurriculum';
import Tabs from './Tabs';
import Headers from '../../Header';

const CourseCurriculum = ({
  isAmateur = true,
  isOnlineDegree = false,
}: {
  isAmateur?: boolean;
  isOnlineDegree?: boolean;
}) => {
  const { courseDetails } = useContext(courseDescriptionContext);

  const { slug } = courseDetails || {};

  const { curriculum, curriculumPdf } = courseDetails?.courseMetaDetails || {};
  const [parents, setParents] = useState<ICurriculum[]>([]);
  const [categories, setCategories] = useState<ICurriculum[]>([]);
  const [activeTab, setActiveTab] = useState<string>(categories?.[0]?._id || '');
  const [modules, setModules] = useState<ICurriculum[]>([]);
  const [lectures, setLectures] = useState<ICurriculum[]>([]);

  useEffect(() => {
    setActiveTab('');
  }, [slug]);

  useEffect(() => {
    if (activeTab === '') setActiveTab(categories?.[0]?._id || '');
  }, [categories]);

  const setAllState = () => {
    const parentsArr: ICurriculum[] = [];

    const categoriesArr = curriculum?.filter((item: ICurriculum) => {
      if (item?.parent) {
        parentsArr.push(item);
      }
      return !item?.parent;
    });

    const contentArr = categoriesArr?.find(({ _id }) => _id === activeTab);

    const modulesArr = parentsArr?.filter(({ parent }) => {
      return parent === contentArr?._id;
    });

    const lecturesArr = parentsArr?.filter((parentId) => {
      return parentId?.parent === modulesArr[0]?._id;
    });
    setParents(parentsArr);
    setLectures(lecturesArr);
    setModules(modulesArr);
    setCategories(categoriesArr || []);
    // setActiveTab(categoriesArr?.[0]?._id || '');
  };

  useEffect(() => {
    setAllState();
  }, [activeTab]);

  return (
    <div>
      {curriculum && curriculum?.length > 0 && (
        <section data-title="Curriculum" id="curriculum" className=" target:bg-white bg-[#F8F8F8] ">
          <Container className="medium:!px-8 large:!px-20 py-9 medium:py-14 flex flex-col gap-4 medium:!gap-10 large:!gap-[60px] ">
            <div className="flex flex-col gap-4 medium:gap-[40px] large:!gap-[60px]">
              {isAmateur && (
                <header className="flex justify-center text-[#3D3D3D]">
                  <Headers
                    title="Course Curriculum"
                    classes="flex w-full !min-w-full justify-center text-gray-850 medium:w-auto text-center !self-center !w-[50%]  medium:!w-full"
                  />
                </header>
              )}
              {!isAmateur && (
                <ProfessionalThemeHeader title="Your Guide To Upskilling: Our Curriculum" />
              )}
              <div className="flex flex-col items-center gap-6 medium:!gap-10 large:!gap-[60px]">
                <Tabs
                  categories={categories}
                  lectures={lectures}
                  modules={modules}
                  activeTab={activeTab || ''}
                  parents={parents}
                  courseDetails={courseDetails}
                  setActiveTab={setActiveTab}
                />
                {curriculumPdf &&
                  courseDetails &&
                  courseDetails?._id?.length > 0 &&
                  !isOnlineDegree && (
                    <DownloadCurriculum
                      curriculumPdf={curriculumPdf}
                      courseName={courseDetails.title}
                      courseId={courseDetails._id}
                      categoryName={courseDetails.parentCategoryDetails?.title}
                      categoryId={courseDetails.parentCategoryDetails?._id}
                      courseType={courseDetails?.pricing?.isFree ? 'free' : 'paid'}
                    />
                  )}
              </div>
            </div>
          </Container>
        </section>
      )}
    </div>
  );
};

export default CourseCurriculum;
